<style scoped>
    @import url("../../styles/smartControl/alertSC.scss");
</style>

<template>
    <div class="box_alertSC">

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-gauge</v-icon>
            <span class="ml-2">Definição dos dispositivos</span>
        </div>

        <div class="painelGeral" v-if="flagMsgSistema">
            <span>Selecione um sistema na página "Início"</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <div class="painelGeral" v-if="!flagMsgSistema && !flagLoadingPainel">

            <DispTable :t="'Atuadores'" :liOrigem="liAtuadores" />
            <DispTable :t="'Sensores'" :liOrigem="liSensores" />
        
        </div>

    </div>
</template>

<script>
import axios from 'axios'

import DispTable from './subDisp/DispTable.vue'

export default {

    components:{DispTable},

    data() {
        return {
            //
            //r:'/dadoslipordia',

            // loading
            flagLoadingPainel:true,

            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.

            emailCliente:'', // -- cliente logado
            execSys:'', // -- sistema current exib

            li:[
                {
                    "titulo":"Iluminação artificial",
                    "unidade":"[min]",
                    "icon":"mdi-ceiling-light-outline",
                    "marcador":"luz",
                    "status":"on"
                }
            ],

            liAtuadores:[],
            liSensores:[],
        }
    },

    methods:{

        preInit() {

            this.flagLoadingPainel = true

            this.sistema = this.$store.state.sistemaSC // v2 14/08/2025
            let cl = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':cl, 'sistema':this.sistema}

            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log(res.data.result)

                const el = res.data.result // agent_unit
                self.liAtuadores = el['atuadores'] // lista de atuadores contendo controladores
                self.liSensores = el['sensores'] // lista de dispositivos contendo sensores

                //console.log('self.liAtuadores: ',self.liAtuadores)
                //console.log('self.liSensores: ',self.liSensores)

                self.flagLoadingPainel = false
            })
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter nome cliente logado (email).
        this.emailCliente = this.$store.state.emailCliente
        //console.log('[father alert] this.emailCliente: ',this.emailCliente)

        // -- obter sistema atual selecionado.
        this.execSys = this.$store.state.sistemaSC
        //console.log('[father alert] execSys: ',this.execSys)

        // -- se sistema vazio, então não buscar o sistema...
        if (this.execSys == '') { this.flagMsgSistema = true; return; } 
        else { 
            this.flagMsgSistema = false
            this.preInit()
        }
    }
}
</script>